export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_02.cc42c20d.jpg";